import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import ErrorLabel from '../ErrorLabel';
import Textarea from '../Textarea';
import ButtonPrimary from '../../../uikit/Buttons/Primary';
import SuccessPopup from '../../SuccessPopup';

import { CAPTCHA_KEY, FORMS_ENDPOINTS } from '../../../utils/constants';
import { constructDevSrc } from '../../../utils/helpers';

import IInputs from '../../../interfaces/IInputs';

interface Props {
	accidentDetailsOfIncidentLabel: string;
	submitButtonLabel: string;
}

function AccidentForm(props: Props) {
	const { accidentDetailsOfIncidentLabel, submitButtonLabel } = props;
	const {
		register,
		handleSubmit,
		formState: { errors, dirtyFields },
		watch,
		reset,
	} = useForm<IInputs>({ mode: 'onChange' });

	const watchAllFields = watch();

	const [isFull, setIsFull] = useState<boolean>(false);
	const [isSucceed, setIsSucceed] = useState<boolean>(false);
	const [isSending, setIsSending] = useState<boolean>(false);

	useEffect(() => {
		isSucceed
			? document.body.classList.add('body-overflow-hidden')
			: document.body.classList.remove('body-overflow-hidden');
	}, [isSucceed]);

	const onClickHandler = () => {
		reset();
		setIsSucceed(false);
		setIsFull(false);
		setIsSending(false);
	};

	useEffect(() => {
		const generalRequiredFields = ['accidentReport'];

		/* @ts-ignore */
		const allTrue = generalRequiredFields.every((field) => {
			/* @ts-ignore */
			if (watchAllFields[field] != false) {
				return true;
			}
			return false;
		});
		if (allTrue && !isSending) {
			setIsFull(true);
		} else {
			setIsFull(false);
		}
	}, [watchAllFields]);

	const onSubmit = async (data: IInputs) => {
		setIsSending(true);
		grecaptcha.ready(() => {
			grecaptcha
				.execute(CAPTCHA_KEY, {
					action: 'accident',
				})
				.then((result) => {
					fetch(constructDevSrc(FORMS_ENDPOINTS.reportAccidentForm), {
						method: 'POST',
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							'g-recaptcha-response': result,
							...data,
						}),
					})
						.then((response) => {
							if (response.status === 200) {
								setIsSucceed(true);
								setIsSending(false);
							}
						})
						.catch((err) => {
							console.log(err.message);
						});
				});
		});
	};

	return (
		<>
			<form className="speaker-form" onSubmit={handleSubmit(onSubmit)}>
				<div className="speaker-form__section">
					<div className="form-row">
						<div className="form-element">
							<Textarea
								inputName="accidentReport"
								label={
									accidentDetailsOfIncidentLabel ||
									'Please give us the details of the incident.'
								}
								invalid={!!errors.accidentReport}
								valid={
									watchAllFields.accidentReport !== '' &&
									dirtyFields.accidentReport &&
									!errors.accidentReport
								}
								required
								rules={{
									required: 'This field is required',
								}}
								register={register}
							/>
							{errors.accidentReport && (
								<ErrorLabel message={errors.accidentReport.message} />
							)}
						</div>
					</div>
				</div>

				<div className="speaker-form__section">
					<div className="form-row form-row--gap-lg form-row--push-right">
						<ButtonPrimary
							disabled={!isFull || Object.keys(errors).length !== 0}
							type="submit"
							submitButtonLabel={
								isSending ? 'Sending' : submitButtonLabel || 'Submit'
							}
						/>
					</div>
				</div>
			</form>
			{isSucceed && (
				<SuccessPopup
					title="Your message was sent successfully."
					content=""
					closePopup={async () => {
						onClickHandler();
					}}
					isActive={isSucceed}
				/>
			)}
		</>
	);
}

export default AccidentForm;
